export const milestones = [
  { year: "2023", title: "从一个时间线文档开始", text: "最初只是编辑组内部用来对齐热点脉络的共享文档，后来发现比刷信息流省事得多，就搬上了站。" },
  { year: "2024", title: "实时楼上线", text: "把「按时间顺序追加」固定成一种内容形态，讨论结束后会自然收束，留下可回查的完整记录。" },
  { year: "2025", title: "建立内容原则", text: "明确不收录个人隐私与未经证实的指控，分类页与热榜都加入了人工剔除环节。" },
  { year: "2026", title: "话题分类体系成型", text: "六个长期方向稳定更新，从娱乐星闻到网络热梗，各自有独立的整理节奏。" },
];

export const testimonials = [
  {
    name: "照晚",
    role: "常年追现场的观众",
    quote: "最舒服的地方是它不逼你站队。同一个话题，前后发生了什么按顺序摆好，看完自己就有判断了。",
  },
  {
    name: "半山雨",
    role: "通勤路上的阅读者",
    quote: "地铁上刷十分钟就能把一个瓜的来龙去脉补完，比在评论区里找线索效率高太多。",
  },
  {
    name: "老陈不熬夜",
    role: "内容从业者",
    quote: "时间线里会特别标出来源类型，哪些是公开渠道、哪些是多手转述，这个细节很少见，但很重要。",
  },
  {
    name: "小满",
    role: "校园媒体编辑",
    quote: "热榜每小时刷新这点很实用，能明显看出一个话题是在上升还是已经回落，不会被情绪带着跑。",
  },
];

export const values = [
  { title: "可核验", text: "每条进展都尽量给出公开来源类型，让自己判断，而不是替你下结论。" },
  { title: "有边界", text: "不碰隐私、不做指控、不制造对立，这是我们长期坚持的底线。" },
  { title: "能回看", text: "话题落幕不代表内容消失，实时楼会保留成一份可以回查的完整记录。" },
];